/**
 * Format date+time for display in statistics: dd.mm.yyyy hh.mm (Russian format, no seconds).
 * Returns '—' for null/undefined/invalid.
 */
export function formatDateTimeRu(value: string | Date | null | undefined): string {
  if (value == null) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hours}.${minutes}`;
}

/**
 * Format date only for display: dd.mm.yyyy (Russian format).
 * Used for period labels and chart axes.
 */
export function formatDateRu(value: string | Date | null | undefined): string {
  if (value == null) return '—';
  const d = new Date(typeof value === 'string' && value.length <= 10 ? value + 'T00:00:00' : value);
  if (Number.isNaN(d.getTime())) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

/**
 * Date range from Monday of current week through today (inclusive).
 * dateTo is tomorrow so backend interval [dateFrom, dateTo) includes today.
 */
export function getWeekRangeMondayToToday(): { dateFrom: string; dateTo: string } {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const daysSinceMonday = (dayOfWeek + 6) % 7;
  const monday = new Date(today);
  monday.setDate(today.getDate() - daysSinceMonday);
  const dateFrom = monday.toISOString().slice(0, 10);
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const dateTo = tomorrow.toISOString().slice(0, 10);
  return { dateFrom, dateTo };
}
